export type TranslateFn = (key: string, params?: Record<string, unknown>) => string;

export function defaultTableName(t: TranslateFn, index: number): string {
  return t("seating.defaults.tableName", { n: index });
}

export function defaultVipTableName(t: TranslateFn): string {
  return t("seating.defaults.vipTable");
}

export function defaultPlanName(t: TranslateFn): string {
  return t("seating.defaults.planName");
}

export function defaultNewPlanName(t: TranslateFn, index: number): string {
  return t("seating.defaults.newPlanName", { n: index });
}
